<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-introduction element-with-heading" epub:type="introduction" id="introduction" role="doc-introduction">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">PRAISE FOR CJ CARVER</h1>
</div>
</div>
</div>
</div>
<div class="text" id="introduction-text">
<div class="alignment-block alignment-block-align-left">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-left"><i>‘A terrific, heart-stopping page-turner… and a heroine with guile as well as guts’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>Harlan Coben</b></p>
<p class="alignment-block-content alignment-block-content-left"><i> </i></p>
<p class="alignment-block-content alignment-block-content-left"><i>‘Do I recommend CJ Carver? Hell yeah! One of my top crime thriller writers’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>Crime Book Junkie</b></p>
<p class="alignment-block-content alignment-block-content-left"><i> </i></p>
<p class="alignment-block-content alignment-block-content-left"><i>‘My goodness, I couldn’t put this book down… amazing. Didn’t see that coming…’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>Josée McClure</b></p>
<p class="alignment-block-content alignment-block-content-left"><i> </i></p>
<p class="alignment-block-content alignment-block-content-left"><i>‘I’ve been a fan of Harlan Coben for years and never found an author to compare until now… Deserves ten stars not five’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>Amazon Customer</b></p>
<p class="alignment-block-content alignment-block-content-left"><i> </i></p>
<p class="alignment-block-content alignment-block-content-left"><i>‘Just when you think you have it figured out, you’re blindsided again’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>Deborah L. Mull</b></p>
<p class="alignment-block-content alignment-block-content-left"><i> </i></p>
<p class="alignment-block-content alignment-block-content-left"><i>‘Mesmerised by all the twists and turns and what a surprising ending. One of the best reads in a long time’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>Doris Johns</b></p>
<p class="alignment-block-content alignment-block-content-left"><i> </i></p>
<p class="alignment-block-content alignment-block-content-left"><i>‘I hated to see it end!’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>Carol</b></p>
<p class="alignment-block-content alignment-block-content-left"><i> </i></p>
<p class="alignment-block-content alignment-block-content-left"><i>‘Wow! Just wow! Great read in one day! Do not usually leave a review but just had to… really fantastic’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>Kindle Customer</b></p>
<p class="alignment-block-content alignment-block-content-left"><i> </i></p>
<p class="alignment-block-content alignment-block-content-left"><i>‘Thrilling… atmospheric, beautifully paced… a fantastic book’</i></p>
<p class="alignment-block-content alignment-block-content-left"><b>The Mystery and Thriller Club</b></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praiseforcjcarver.vue?0e58cb46